
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CurriculumManager from '@/components/curriculum/CurriculumManager';
import AIGovernanceDashboard from '@/components/ai/AIGovernanceDashboard';
import EnhancedSearch from '@/components/search/EnhancedSearch';
import { 
  GraduationCap, 
  Brain, 
  Search,
  Sparkles
} from 'lucide-react';

const Phase6Manager: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Sparkles className="h-6 w-6" />
        <h1 className="text-3xl font-bold">AI & Learning Dashboard</h1>
      </div>

      <Tabs defaultValue="curriculum" className="space-y-6">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="curriculum" className="flex items-center gap-2">
            <GraduationCap className="h-4 w-4" />
            Curriculum Management
          </TabsTrigger>
          <TabsTrigger value="search" className="flex items-center gap-2">
            <Search className="h-4 w-4" />
            Search Optimization
          </TabsTrigger>
          <TabsTrigger value="ai-governance" className="flex items-center gap-2">
            <Brain className="h-4 w-4" />
            AI Governance
          </TabsTrigger>
        </TabsList>

        <TabsContent value="curriculum">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <GraduationCap className="h-5 w-5" />
                Reader Curriculum Management
              </CardTitle>
            </CardHeader>
            <CardContent>
              <CurriculumManager />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="search">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Search className="h-5 w-5" />
                Search & Index Optimization
              </CardTitle>
            </CardHeader>
            <CardContent>
              <EnhancedSearch />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="ai-governance">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Brain className="h-5 w-5" />
                AI Governance Module
              </CardTitle>
            </CardHeader>
            <CardContent>
              <AIGovernanceDashboard />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Phase6Manager;

